"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var RangeSliderHandle = function RangeSliderHandle(_ref) {
  var value = _ref.value,
      offset = _ref.offset,
      prefix = _ref.prefix,
      suffix = _ref.suffix;
  var styles = {
    left: "".concat(offset, "%")
  };
  return _react.default.createElement("div", {
    className: "RangeSliderHandle-container",
    style: styles
  }, _react.default.createElement("div", {
    className: "RangeSliderHandle"
  }), _react.default.createElement("div", {
    className: "RangeSliderHandle-label"
  }, prefix, value, suffix));
};

RangeSliderHandle.propTypes = {
  /** The current value of the slider. */
  value: _propTypes.default.number,

  /** The offset value (percentage) for the handle container style. */
  offset: _propTypes.default.number,

  /** The prefix for the handle label. */
  prefix: _propTypes.default.string,

  /** The suffix for the handle label. */
  suffix: _propTypes.default.string
};
var _default = RangeSliderHandle;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(RangeSliderHandle, "RangeSliderHandle", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/RangeSlider/RangeSliderHandle.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/RangeSlider/RangeSliderHandle.jsx");
  leaveModule(module);
})();

;